"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.localizedMessage = exports.registerMessageCommon = exports.MessageCommon = void 0;
/**
 * MessageCommon
 *
 * This is a reusable React component to display a message code i.e. epic.odin.home.title
 * It works in tandom with a LocalizationStore and thus requires the registerMessageCommon() to be called before it will work.
 *
 */
const react_1 = __importDefault(require("react"));
const epic_alt_utils_1 = require("epic-alt-utils");
const prop_types_1 = __importDefault(require("prop-types"));
const window_or_global_1 = __importDefault(require("window-or-global"));
/* Global __TEST__ var */
const { __TEST__ } = window_or_global_1.default;
//reference to the registered alt store
let locStore;
let MessageCommon = class MessageCommon extends react_1.default.Component {
    static getStores() {
        return [locStore];
    }
    static getPropsFromStores() {
        return {
            localizationStore: locStore.getState()
        };
    }
    render() {
        const { code, args, localizationStore, className } = this.props;
        if (!localizationStore || !localizationStore.message) {
            console.warn('localizationStore.state.message() is not property set');
            return react_1.default.createElement("span", null);
        }
        let message = localizationStore.message(code, args);
        if (!message && !__TEST__) {
            console.warn('message code not found:', code);
        }
        message = message || code;
        return react_1.default.createElement("span", { className: className, dangerouslySetInnerHTML: { __html: message } });
    }
};
MessageCommon.propTypes = {
    code: prop_types_1.default.string,
    args: prop_types_1.default.array,
    className: prop_types_1.default.string,
    localizationStore: prop_types_1.default.object
};
MessageCommon = __decorate([
    epic_alt_utils_1.connectToStores
], MessageCommon);
exports.MessageCommon = MessageCommon;
/**
 * Use this to setup and use the MessageCommon class.  It requires a LocalizationStore param.
 * @param  {LocalizationStore} store
 * @return {<MessageCommon />}
 */
function registerMessageCommon(store) {
    locStore = store;
    return MessageCommon;
}
exports.registerMessageCommon = registerMessageCommon;
function localizedMessage(code, args) {
    return locStore.getState().message(code, args);
}
exports.localizedMessage = localizedMessage;
//# sourceMappingURL=MessageCommon.js.map